import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=1c4dcf88&scoped=true&"
import script from "./Photography.vue?vue&type=script&lang=js&"
export * from "./Photography.vue?vue&type=script&lang=js&"
import style0 from "./Photography.vue?vue&type=style&index=0&id=1c4dcf88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dcf88",
  null
  
)

export default component.exports